import { render, staticRenderFns } from "./configureKiosk.vue?vue&type=template&id=0fc70674"
import script from "./configureKiosk.vue?vue&type=script&lang=js"
export * from "./configureKiosk.vue?vue&type=script&lang=js"
import style0 from "./configureKiosk.vue?vue&type=style&index=0&id=0fc70674&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports